/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动唯一ID
   */
  event_id: string;
}
/**
 * 发布校验违规项列表
 */
export type Items = {
  /**
   * 违规项类别
   */
  error_type: string;
  /**
   * 违规项提示信息
   */
  msg: string;
  /**
   * 违规项优先级，用于排序
   */
  order: number;
  /**
   * 1:机器审核不通过 2:发布失败;3:人工审核不通过
   */
  sort: number;
}[];
/**
 * 发布前告警列表
 */
export type WarningItems = {
  error_type: string;
  msg: string;
  order: string;
}[];
export interface DashboardEventCheckBeforePublishRes {
  msg?: string;
  data: Data;
  nonce?: string;
  code?: number;
}
export interface Data {
  real_name_verify_info: {
    corp_real_name_means_list: string[];
    // 0代表已实名， 1代表未实名
    code: number,
    // 提示实名认证内容
    content: string,
    // 是否在缓冲期内
    is_in_buffer: boolean,
  };
  items: Items;
  warning_items: WarningItems;
  /**
   * 第一个items参数的报错中心分类。1:机器审核不通过 2:发布失败;3:人工审核不通过
   */
  items_sort: number;
}

const DashboardEventCheckBeforePublish = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventCheckBeforePublishRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/check-before-publish',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventCheckBeforePublish;
